export const parseUah = (string) => parseFloat(string).toFixed(2)
